export default "__VITE_ASSET__B5vlQbhs__"